// extracted by mini-css-extract-plugin
export default {"base":"WidgetStatus_base__UnVza","emoji":"WidgetStatus_emoji__EpnRQ"};